export default {
	ajaxurl: window.location.origin + "/wp-admin/admin-ajax.php",
};
